module.exports = __webpack_public_path__ + "img/aniversario_7.8f9cb997.jpg";